import React, { useRef, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Title, Camera } from '@fnacdarty/back-office-ui';
import {
	StyledContainer,
	StyledLabel,
	StyledDeleteIcon,
	StyledError,
	StyledActions,
	StyledSuccess,
	StyledText,
	StyledeFileName,
} from './index.styled';
import { StyledRowPrimaryText } from '../ActivityFile/index.styled';
import deleteIcon from '../../../../assets/images/logos/picto_delete.png';
import {
	getBase64,
	uploadDocument,
	confirmationSendDocument,
} from '../../utils/activity';
import * as errors from '../../../../utils/errors';

const ActivityFileUpload = ({ activity, setOpenModal, data }) => {
	const [selectedDocuments, setSelectedDocuments] = useState([]);
	const fileInput = useRef(null);
	const [status, setStatus] = useState({
		loading: false,
		errorFormat: '',
		errorSize: '',
		errorUploadFile: '',
		success: false,
		libelleButton: 'Annuler',
	});

	const [favoriteCamera, setFavoriteCamera] = useState(
		localStorage.getItem('favoriteCamera') || false,
	);

	const [isCameraOpen, setIsCameraOpen] = useState(false);
	const [picture, setPicture] = useState({
		content: null,
		isPreviewUpload: false,
		file: null,
	});

	const pictureCallback = (file, content) => {
		setPicture({
			...picture,
			content,
			isPreviewUpload: true,
			file,
		});
		setSelectedDocuments([...selectedDocuments, file]);

		setIsCameraOpen(false);
	};

	const setFile = (newFile) => {
		setPicture({ ...picture, file: newFile });
	};

	const openCamera = () => {
		setIsCameraOpen(true);
	};

	const isVersionPC = () =>
		window.innerWidth >= `${process.env.REACT_APP_PC_VERSION}`;

	const validateFile = (e) => {
		const files = [...e.target.files];
		const mimeType = [
			'application/pdf',
			'image/jpeg',
			'image/png',
			'image/gif',
		];
		const extension = ['jpg', 'jpeg', 'png', 'gif', 'pdf'];
		let error = '';
		let valide = true;
		let totalSize = 0;
		let size = 0;
		files.forEach((file) => {
			const extensionPart = file.type.split('/');
			const dataMimeType = mimeType.filter((item) => item === file.type);
			const dataExtension = extension.filter(
				(item) => item === extensionPart[1].toLowerCase(),
			);

			if (dataMimeType.length === 0 || dataExtension.length === 0) {
				error = errors.ERROR_FORMAT_CONTENT_DOCUMENT;
				valide = false;
			}
			size = file.size / 1024 / 1024;
			if (size > 8) {
				error = errors.ERROR_SIZE_DOCUMENT;
				valide = false;
			}
			totalSize += size;
			if (valide) {
				if (totalSize > 8) {
					error = errors.ERROR_SIZE_DOCUMENTS;
					valide = false;
				}
			}
		});
		let sizeSelectedFiles = 0;
		let j = 0;
		for (j; selectedDocuments.length > j; j += 1) {
			sizeSelectedFiles += selectedDocuments[j].size / 1024 / 1024;
		}

		if (sizeSelectedFiles + totalSize > 8) {
			error = errors.ERROR_SIZE_DOCUMENTS;
			valide = false;
		}

		return { valide, msg: error };
	};

	const generateHash = () => {
		const hash = `${Math.random().toString(36)}00000000000000000`.slice(
			2,
			7,
		);

		return hash;
	};

	const handleDocumentUpload = (e) => {
		const valideFile = validateFile(e);

		setStatus({
			...status,
			errorFormat: valideFile.msg,
		});

		const extension = ['jpg', 'jpeg'];

		if (valideFile.valide) {
			if (!isVersionPC()) {
				const filesUploaded = [...e.target.files];
				const newFiles = [];
				filesUploaded.forEach((fichier) => {
					const namePart = fichier.name.split('.');
					let newFileName = `${`${namePart[0]}_${generateHash()}`}.${
						namePart[namePart.length - 1]
					}`;
					const dataExtension = extension.filter(
						(item) =>
							item ===
							namePart[namePart.length - 1].toLowerCase(),
					);

					if (dataExtension.length === 0) {
						newFileName = fichier.name;
					}
					newFiles.push(
						new File([fichier], newFileName, {
							type: fichier.type,
							lastModified: fichier.lastModified,
						}),
					);
				});

				setSelectedDocuments([...selectedDocuments, ...newFiles]);
			} else {
				setSelectedDocuments([...selectedDocuments, ...e.target.files]);
			}

			setStatus({
				...status,
				success: false,
				errorFormat: '',
				errorSize: '',
				errorUploadFile: '',
			});
		}
	};

	const handleSubmit = async (response) => {
		if (response) {
			if (selectedDocuments.length > 0) {
				let i = 0;
				let sendocument = true;
				for (i; selectedDocuments.length > i; i += 1) {
					// eslint-disable-next-line no-await-in-loop
					const content = await getBase64(selectedDocuments[i]);

					// eslint-disable-next-line no-await-in-loop
					const result = await uploadDocument({
						fileName: selectedDocuments[i].name,
						mimeType: selectedDocuments[i].type,
						nuint: activity.nuint,
						project: activity.project,
						constantName: activity.link.constantName,
						formName: activity.link.formName,
						libelle: activity.link.libelle,
						content,
					});
					if (!result) {
						sendocument = false;
						setStatus({
							...status,
							errorUploadFile: errors.ERROR_UPLOAD_DOCUMENTS,
						});
					}
				}

				if (selectedDocuments.length === i && sendocument) {
					const resultConfirm = await confirmationSendDocument({
						nuint: activity.nuint,
						project: activity.project,
					});
					if (resultConfirm && resultConfirm.id) {
						setStatus({
							...status,
							success: true,
							errorUploadFile: '',
							libelleButton: 'Fermer',
						});
						setSelectedDocuments([]);
					} else {
						setStatus({
							...status,
							errorUploadFile: errors.ERROR_UPLOAD_DOCUMENTS,
						});
					}
				}
			}
		} else {
			setOpenModal(false);
		}
	};

	const removeFile = (index) => () => {
		const newFiles = selectedDocuments.filter(
			(item) => item.name !== index,
		);
		setSelectedDocuments(newFiles);
	};

	let fontSizeNameFile = '13.5px';
	if (!isVersionPC()) {
		fontSizeNameFile = '10.5px';
	}
	const renderFileName = (fileName) => {
		if (!isVersionPC()) {
			if (fileName.length > 43) {
				return `${fileName.substr(0, 37)}...`;
			}
			return fileName;
		}
		return fileName;
	};

	return (
		<StyledContainer>
			{!status.success ? (
				<StyledText>
					<p>
						Vous avez réalisé {data.libelleActivity} de notre
						client.
					</p>
					<p>
						Merci de nous faire parvenir <br /> le dossier de{' '}
						{data.dossierActivity}
					</p>
					<p></p>
					<StyledRowPrimaryText>
						<Title level={3}>{activity.customer.name}</Title>
					</StyledRowPrimaryText>
				</StyledText>
			) : null}
			{!status.success ? (
				<StyledText>
					<b style={{ fontSize: '16px' }}>Chantier:</b>{' '}
					{activity.project}
				</StyledText>
			) : null}
			{!status.success ? (
				<StyledLabel htmlFor="file">Télécharger</StyledLabel>
			) : null}
			{!status.success ? (
				<input
					type="file"
					id="file"
					multiple
					style={{ display: 'none' }}
					onChange={handleDocumentUpload}
					ref={fileInput}
				/>
			) : null}
			{/*! status.success && !isVersionPC() && (
				<StyledLabel onClick={openCamera}>
					Prendre une photo
				</StyledLabel>
			) */}
			{/* isCameraOpen && (
				<Camera
					pictureCallback={pictureCallback}
					setIsCameraOpen={setIsCameraOpen}
					defaultCamera={favoriteCamera}
				/>
			) */}
			<div>
				{selectedDocuments.length > 0 &&
					selectedDocuments.map((file) => (
						<StyledeFileName
							key={file.name}
							style={{
								fontSize: fontSizeNameFile,
								width: '100%',
							}}
						>
							{renderFileName(file.name)}
							<StyledDeleteIcon>
								<img
									src={deleteIcon}
									onClick={removeFile(file.name)}
								/>
							</StyledDeleteIcon>
						</StyledeFileName>
					))}
			</div>
			<StyledActions className="actions">
				<span
					className="action action--secondary action-cancel"
					onClick={() => {
						handleSubmit(false);
					}}
				>
					{status.libelleButton}
				</span>

				{!status.success ? (
					<span
						className="action action--primary action-send"
						onClick={() => {
							handleSubmit(true);
						}}
					>
						Envoyer
					</span>
				) : null}
			</StyledActions>

			{status.errorSize ? (
				<StyledError className="error">{status.errorSize}</StyledError>
			) : null}
			{status.errorFormat ? (
				<StyledError className="error">
					{status.errorFormat}
				</StyledError>
			) : null}
			{status.errorUploadFile ? (
				<StyledError className="error">
					{status.errorUploadFile}
				</StyledError>
			) : null}
			{status.success ? (
				<StyledSuccess className="success">
					Les documents ont été déposés avec succès
				</StyledSuccess>
			) : null}
			{!status.success ? (
				<p style={{ fontSize: '10px', color: 'orange' }}>
					La taille maximale par fichier est limitée à 2 Mo
				</p>
			) : null}
		</StyledContainer>
	);
};
ActivityFileUpload.propTypes = {
	activity: PropTypes.object,
	setOpenModal: PropTypes.func,
	data: PropTypes.object,
};
export default ActivityFileUpload;
